﻿
import Vue from "vue";
import './style.scss';

var previousAjax;
var nextCallback = null;
var xhrCount = 0;


var basePath = window.app.base;
var instance = new Vue({
    data: {
        modalTitle: '',
        type: '',
        columns: [{ name: "Naziv", title: "Naziv" }, { name: "Pib", title: "PIB" }, { name: "Adresa", title: "Adresa" }],
        //rows: [{ MatBr: "123456", Aop: "123" }],
        //columns: [],
        rows: [],
        selectedItem: {},
        searchForm: {
            typeText: "Naziv",
            typeId: 0,
            modelText: "",
            modelSelect: 0
        }
    },
    methods: {
        setSearchType: function (id, type) {
            this.searchForm.typeId = id;
            this.searchForm.typeText = type;
            this.searchForm.modelText = "";
            this.searchForm.modelSelect = 0;

            this.columns = [];
            this.rows = [];
        },

        onInput: function () {

            var q = this.searchText;
            var c = this;

            var ajaxUrl = basePath +"Home/SearchAutoComplete";
            var data = { q: c.searchForm.modelText, includeMostUsed: true };

            var seqNumber = ++xhrCount;

            previousAjax = $.ajax({
                url: ajaxUrl,
                method: "GET",
                data: data
            }).then(function (result) {
                if (seqNumber === xhrCount) {
                    for (var i = 0; i < result.length; i++) { 
                        result[i]._isSelected = false;
                    }
                    c.rows = result;
                }

            }).fail(function () {
                // on fail .......
            });
        },

        selectItem: function (re) {
            for (var i = 0; i < this.rows.length; i++) {
                this.rows[i]._isSelected = false;
            }
            this.selectedItem = re;
            re._isSelected = true;
        },

        openPrompt: function (type, modalTitle, callback) {
            this.onInput();

            $(this.$el).modal('show');
            $(this.$el).find("input[type='text']").focus();

            this.modalTitle = modalTitle;
            this.type = type;
            nextCallback = callback;

            $(this.$el).on('hidden.bs.modal', function () {
                $("body").addClass("modal-open");
            });
        },

        cancel: function () {
            $(this.$el).modal('hide');

        },

        save: function () {
            var item = this.selectedItem;

            $(this.$el).modal('hide');

            nextCallback(item);
        }
    }
});


var component = {
    v: instance,
    name: "popup-reference-obveznik"
};

export default component;